/**
 * useCountdown Hook
 *
 * Displays a countdown timer for HITL requests with timeouts.
 * Updates every second while the component is mounted.
 */

import { useState, useEffect } from 'react'

/**
 * Returns a formatted countdown string ("45s", "1m 30s") or null if no timeout.
 * Returns "0s" when expired.
 */
export function useCountdown(
  receivedAt: number,
  timeoutMs?: number
): string | null {
  const [now, setNow] = useState(Date.now())

  useEffect(() => {
    if (!timeoutMs) return

    const interval = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(interval)
  }, [timeoutMs])

  if (!timeoutMs) return null

  const elapsed = now - receivedAt
  const remaining = Math.max(0, timeoutMs - elapsed)
  const totalSeconds = Math.ceil(remaining / 1000)

  if (totalSeconds <= 0) return '0s'

  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  if (minutes > 0) {
    return seconds > 0 ? `${minutes}m ${seconds}s` : `${minutes}m`
  }
  return `${seconds}s`
}
